import { HireActiveStatus } from '@/gql/graphql'

export function canEditHireContract(activeStatus?: HireActiveStatus | null): boolean {
  return (
    !!activeStatus &&
    activeStatus !== HireActiveStatus.Cancelled &&
    activeStatus !== HireActiveStatus.Terminated
  )
}
